
import { defineComponent } from 'vue';

const DEFAULT_LOADING_ANIMATION = 1;
const AVAILABLE_LOADING_ANIMATIONS = [1, 2];

const defaultColors: Record<number, { color1: string; color2: string }> = {
  1: {
    color1: 'var(--bc-blue-2)',
    color2: 'var(--bc-yellow-2)',
  },
  2: {
    color1: 'rgb(88, 173, 228)',
    color2: '',
  },
};

const defaultDimensions: Record<number, { width: number; height: number }> = {
  1: {
    width: 48,
    height: 48,
  },
  2: {
    width: 40,
    height: 40,
  },
};

export default defineComponent({
  name: 'BCLoadingAnimation',
  props: {
    loadingAnimation: {
      type: Number,
      default: DEFAULT_LOADING_ANIMATION,
      validator: (value: number): boolean => AVAILABLE_LOADING_ANIMATIONS.includes(value),
    },
    color1: {
      type: String,
      default: '',
    },
    color2: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    resolvedLoadingAnimation(): number {
      return this.loadingAnimation || DEFAULT_LOADING_ANIMATION;
    },
    resolvedColors(): { color1: string; color2: string } {
      const colors = defaultColors[this.resolvedLoadingAnimation];

      return {
        color1: this.color1 || colors.color1,
        color2: this.color2 || colors.color2,
      };
    },
    resolvedDimensions(): { width: number; height: number; scaleSize: number } {
      const dimensions = defaultDimensions[this.resolvedLoadingAnimation];

      if (this.size > 0) {
        return {
          width: this.size,
          height: this.size,
          scaleSize: this.size,
        };
      }

      return {
        ...dimensions,
        scaleSize: dimensions.width,
      };
    },
    loadingAnimationStyle(): Record<string, string> {
      return {
        '--bc-loading-animation-size': `${this.resolvedDimensions.scaleSize}px`,
        '--bc-loading-animation-color-1': this.resolvedColors.color1,
        '--bc-loading-animation-color-2': this.resolvedColors.color2,
        '--bc-loading-animation-cube-face-bg': 'transparent',
        width: `${this.resolvedDimensions.width}px`,
        height: `${this.resolvedDimensions.height}px`,
      };
    },
    loadingAnimationClass(): string[] {
      return [
        'bc-loading-animation__item',
        `bc-loading-animation__item--${this.resolvedLoadingAnimation}`,
      ];
    },
    cubeFaces(): string[] {
      return [
        'rotateY(0deg)',
        'rotateY(180deg)',
        'rotateY(90deg)',
        'rotateY(-90deg)',
        'rotateX(90deg)',
        'rotateX(-90deg)',
      ];
    },
  },
});
